<template>
  <div style="display: flex; width: 780px">
    <div class="form-column">
      <el-form class="result-form">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td class="header">{{ $t('FileHistory.fileName') }}</td>
            <td style="width: 300px;"><span>{{ details.fileName }}</span></td>
            <td class="header">{{ $t('SeaExport.BusinessNumber') }}</td>
            <td style="width: 300px;"><el-input v-model="details.jobNo" no="customerRefNo" /></td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_ItemsNBR') }}</td>
            <td><el-input v-model="resultJson.number" no="1" @focus="handleFocus('number')" /></td>
            <td class="header">{{ $t('SeaExport.Weight') }}</td>
            <td><el-input v-model="resultJson.weight" no="2" @focus="handleFocus('number')" /></td>
          </tr>
          <tr>
            <td class="header">{{ $t('SeaExport.DateOfCustomsDeclaration') }}</td>
            <td>
              <el-date-picker
                v-model="resultJson.customsDate"
                no="3"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 300px;"
                @focus="handleFocus('customsDate')"
              />
            </td>
            <td class="header">{{ $t('CargoMsg.Cargo_CustomsDeclarationNo') }}</td>
            <td><el-input v-model="resultJson.customsDeclarationNo" no="4" @focus="handleFocus('customsDeclarationNo')" /></td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_FOBValue') }}</td>
            <td><el-input v-model="resultJson.freeOnBoard" no="5" @focus="handleFocus('freeOnBoard')" /></td>
            <td class="header">{{ $t('CargoMsg.Cargo_AmountNumber') }}</td>
            <td><el-input v-model="resultJson.quantity" no="6" @focus="handleFocus('quantity')" /></td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_ProcessingFee') }}</td>
            <td><el-input v-model="resultJson.processingFee" no="7" @focus="handleFocus('processingFee')" /></td>
            <td class="header">{{ $t('CargoMsg.Cargo_ExchangeRate2') }}</td>
            <td><el-input v-model="resultJson.rate" no="8" @focus="handleFocus('rate')" /></td>
          </tr>
          <tr>
            <td class="header">{{ $t('CargoMsg.Cargo_InsurancePremium') }}</td>
            <td><el-input v-model="resultJson.insurancePremium" no="9" @focus="handleFocus('insurancePremium')" /></td>
            <td class="header">{{ $t('CargoMsg.Cargo_SystemFee') }}</td>
            <td><el-input v-model="resultJson.systemFee" no="10" @focus="handleFocus('systemFee')" /></td>
          </tr>
        </table>
      </el-form>
    </div>

  </div>
</template>

<script>
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'ResultFormSeCustoms',
  components: { CargoRichTextarea, AutoNumberInput, CargoUserSelect, CargoAdvanceSelect, CargoPackingSelect, cargoCompanySelect },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    index: { type: Number, default: 0 },
    resultArray: { type: Array, default: () => [] }
  },
  data() {
    return {
      resultJson: {},
      SystemConstants,
      ColumnUtils,
      selectTypeNames: TYPE_NAMES,
      customsInfo: {}
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    index(val, oldVal) {
      if (val !== oldVal) {
        this.resultJson = this.resultArray[val].text.data
        this.customsInfo = this.resultJson.jobJson
      }
    }
  },
  async created() {
    this.init()
  },
  methods: {
    handleFocus(val) {
      this.$emit('fieldFocus', val)
    },
    init() {
      this.resultJson = this.resultArray[this.index].text.data
      this.customsInfo = this.resultJson.jobJson
    }
  }
}
</script>

<style lang="scss" scoped>
.result-form{
  padding: 10px;
  table{
    width: 100%;
    tr{
      td {
        border: 1px solid #DCDFE6;
        height: 30px;
        &.header {
          width: 70px;
          text-align: center;
        }
        .el-form-item{
          margin: 0!important;
          input{
            border:none!important;
          }
        }
        .mapperClass {
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .is-require {
    color: #4abff3;
  }
}
</style>
